/* eslint-disable @next/next/no-img-element */
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { Spacings, breakpoints } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import useScholarshipTestInfo from '@api/hooks/scholarship/useScholarshipTestInfo';
import { useIsMobile } from '@stores/AppCommonData';

const Wrapper = styled.div`
  cursor: pointer;
  width: 1136px;
  margin: auto;
  margin-bottom: 110px;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 100%;
    padding: ${Spacings.SPACING_4B};
    margin-bottom: 80px;
    height: auto;
  }
  img {
    width: 100%;
    height: 100%;
    box-shadow: ${boxShadowGenerator()};
    border-radius: 8px;
  }
`;

const PromotionalBanner = () => {
  const {
    query: { eventKey }
  } = useRouter();
  const { prodigyInfo } = useScholarshipTestInfo(eventKey);

  const isMobile = useIsMobile();

  const { promotionalBanner } = prodigyInfo;

  if (!promotionalBanner) return null;
  return (
    <Wrapper
      onClick={
        promotionalBanner.permalink
          ? () => window.open(promotionalBanner.permalink)
          : null
      }
    >
      <img
        src={isMobile ? promotionalBanner.mwImage : promotionalBanner.webImage}
        alt="promotional-banner"
      />
    </Wrapper>
  );
};

export default PromotionalBanner;
